module.exports = __webpack_public_path__ + "static/media/step5.3af6a41b.svg";